// react
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// type
import { GuardPropsType } from 'types';

const AuthGuard = ({ children }: GuardPropsType) => {
  const { isLoggedIn, isValidEmail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('login', {
        state: {
          from: null
        },
        replace: true
      });
    }

    if (!isValidEmail && location.pathname.indexOf('/rental/mypage/customer') === -1) {
      navigate('/rental/mypage/customer', {
        state: {
          from: null
        },
        replace: true
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, isValidEmail, location]);

  return children;
};

export default AuthGuard;
